import React, { useEffect, useState } from 'react';
import SpeakersPreviewModuleHead from '../../components/SpeakersPreviewModuleHead/index';
import './style.scss';

interface SpeakersPreviewModuleProps {
  content: {
    title: string;
    titleAlign: 'start' | 'end' | 'left' | 'right' | 'center' | 'justify' | 'match-parent';
    api: string;
    vars: object;
  };
  getData: Function;
  getImage: Function;
  openPopover: Function;
  baseUrl: string;
  partnerBucket: string;
  api: string;
}

const SpeakersPreviewModule: React.FC<SpeakersPreviewModuleProps> = ({
  content: { title, titleAlign, vars },
  api,
  partnerBucket,
  getData,
  getImage,
  openPopover,
}) => {
  const [speakerList, setSpeakerList] = useState([]);
  const align = titleAlign ? titleAlign : null;
  const endPoint = api
    ? //@ts-ignore
      CrowdHub_App.CONFIG.BASE_URL + api
    : //@ts-ignore
      CrowdHub_App.CONFIG.BASE_URL + 'crowdhub_api_v2/api_content_oneAndOnlyList.php';

  useEffect(() => {
    let speakers = getData(
      endPoint,
      vars,
      function (data) {
        if (data.success == 'true') {
          setSpeakerList(data.content);
        }
      },
      function () {
        console.warn('Error retrieving speakers');
      },
    );
  }, []);

  if (speakerList.length == 0) {
    return <></>;
  }

  return (
    <div className="speakers_preview_module ui_relative element">
      <div style={{ textAlign: align }} className="speaker_preview_title title ui_textalign_center primary-font-family">
        {title}
      </div>
      <div className="speaker_heads_container">
        {speakerList.map(speaker => {
          return (
            <SpeakersPreviewModuleHead
              key={speaker.content_id}
              openPopover={openPopover}
              getImage={getImage}
              partnerBucket={partnerBucket}
              speaker={speaker}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SpeakersPreviewModule;

// {data.success == 'pending' ? (

// ) : (

// )}
